import { CategoryComponentEntryValue } from '@osos/shared/api';
import { LocalizedValueModel } from '../localized-value.model';

export class SpaceEntryPresenterModel {
  id?: string;
  dataEntity: string;
  entityVersion?: number;
  isEntryObsolete?: boolean;
  isEntryInvalid?: boolean;
  specificationVersion?: number;
  name: LocalizedValueModel;
  description: LocalizedValueModel | null;
  type: CategoryComponentEntryValue;
  is_deactivated: boolean;
  is_end_user_deactivated: boolean;
  url: string;
  domainIdentifier: string;
  fullUrl: string;
  icon: string;
  isImplicit?: boolean;
}
